import React, { useState } from "react";
import Box, { Item } from "devextreme-react/box";
import { CustomInput } from "../../common/SimpleInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import SubStateMenu from "./SubStateMenu";

function TaxonomyForm(props) {
  const {
    taxonomyValues,
    entryChannelsOptions,
    taxonomyOptions,
    caseOptions,
    caseValue,
    changeTaxonomy,
    changeCaseValue,
    changeDate,
    dateValue,
    loading,
    closed,
    caseNumber,
    additionalInfo,
    changeAdditionalInfo,
    changeCaseNumber,
    changeEntryChannel,
    entryChannelValue,
    factoryCloseDateValue,
    scaleDateValue,
    nonPPReasonValue,
    changeFactoryCloseDate,
    changeScaleDate,
    changeNonPPReason,
    changeSubState,
    subStateValue,
  } = props;
  const [showMenu, setShowMenu] = useState(false);

  return (
    <div className="caseform-form">
      <Box direction="row" width="100%" height={"70px"}>
        <Item ratio={1}>
          <CustomInput
            label="Canal de entrada"
            type="select"
            disableClear
            disabled={loading || closed || !entryChannelsOptions}
            //disabled={true}
            displayExpr={"description"}
            valueExpr={"entryChannelId"}
            options={entryChannelsOptions || []}
            onChange={(e) => changeEntryChannel(e)}
            value={entryChannelValue}
          />
        </Item>
        <Item ratio={1}>
          <CustomInput
            label="Nível 1"
            type="select"
            disabled={loading || closed || !taxonomyOptions.level_1}
            displayExpr={"value"}
            valueExpr={"key"}
            options={taxonomyOptions.level_1 || []}
            onChange={(e) => changeTaxonomy(e, 1)}
            value={taxonomyValues.taxonomyLevel_1}
          />
        </Item>
        <Item ratio={1}>
          <CustomInput
            label="Nível 2"
            type="select"
            disabled={
              loading ||
              closed ||
              taxonomyValues.level < 1 ||
              !taxonomyOptions.level_2 ||
              taxonomyOptions.level_2.length === 0
            }
            displayExpr={"value"}
            valueExpr={"key"}
            options={taxonomyOptions.level_2 || []}
            onChange={(e) => changeTaxonomy(e, 2)}
            value={taxonomyValues.taxonomyLevel_2}
          />
        </Item>
      </Box>
      <Box direction="row" width="100%" height={"70px"}>
        <Item ratio={1}>
          <CustomInput
            label="Nível 3"
            type="select"
            disabled={
              loading ||
              closed ||
              taxonomyValues.level < 2 ||
              !taxonomyOptions.level_3 ||
              taxonomyOptions.level_3.length === 0
            }
            displayExpr={"value"}
            valueExpr={"key"}
            options={taxonomyOptions.level_3 || []}
            onChange={(e) => changeTaxonomy(e, 3)}
            value={taxonomyValues.taxonomyLevel_3}
          />
        </Item>
        <Item ratio={1}>
          <CustomInput
            label="Nível 4"
            type="select"
            disabled={
              loading ||
              closed ||
              taxonomyValues.level < 3 ||
              !taxonomyOptions.level_4 ||
              taxonomyOptions.level_4.length === 0
            }
            displayExpr={"value"}
            valueExpr={"key"}
            options={taxonomyOptions.level_4 || []}
            onChange={(e) => changeTaxonomy(e, 4)}
            value={taxonomyValues.taxonomyLevel_4}
          />
        </Item>
        <Item ratio={1}>
          <Box height={"100%"}>
            <Item ratio={9}>
              <CustomInput
                label="Status"
                disableClear
                type="select"
                disabled={loading || closed}
                displayExpr={"description"}
                valueExpr={"stateId"}
                options={caseOptions}
                value={caseValue}
                onChange={(e) => changeCaseValue(e)}
              />
            </Item>
            {/* <Item
              disabled={loading || closed}
              ratio={1}
              style={{ justifyContent: "center" }}
              className={"subState-wrapper"}
            >
              <FontAwesomeIcon
                icon={faInfoCircle}
                title={"Ver subestados"}
                className={"subState-button"}
                style={{ opacity: loading || closed ? ".5" : "1" }}
                onClick={() => setShowMenu(!showMenu)}
                id="menuIcon"
              />
              <SubStateMenu
                showMenu={showMenu}
                value={subStateValue}
                handleChange={changeSubState}
                setShowMenu={setShowMenu}
                menuOptions={
                  caseOptions.length > 0
                    ? caseOptions.find((o) => o.stateId == caseValue)?.subStates
                    : []
                }
              />
            </Item> */}
          </Box>
        </Item>
      </Box>
      <Box direction="row" width="100%" height={"70px"}>
        {/* <Item ratio={1}>
          <CustomInput
            label="Data agendada"
            clearField={() => changeDate(null)}
            type="date"
            disabled={loading || closed}
            onChange={(e) => {
              changeDate(e);
            }}
            value={dateValue}
            datetype={"datetime"}
          />
        </Item> */}
         <Item ratio={1}>
          <CustomInput
            label="Data de escalonamento"
            clearField={() => changeScaleDate(null)}
            type="date"
            disabled={loading || closed}
            onChange={(e) => {
              changeScaleDate(e);
            }}
            value={scaleDateValue}
            datetype={"datetime"}
          />
        </Item>
        <Item ratio={1}>
          <CustomInput
            size={"xxs"}
            disabled={closed}
            onChange={(e) => {
              changeAdditionalInfo(e);
            }}
            label="Informação adicional"
            type="text"
            value={additionalInfo}
            maxValue={2000}
          />
        </Item>
        
      </Box>
      {/* <Box direction="row" width="100%" height={"70px"}>
       <Item ratio={1}>
          <CustomInput
            size={"xxs"}
            disabled={closed}
            onChange={(e) => {
              changeCaseNumber(e);
            }}
            label="Nº de caso en fábrica"
            type="text"
            value={caseNumber}
          />
        </Item>
        <Item ratio={1}>
          <CustomInput
            label="Fecha de cierre fábrica"
            clearField={() => changeFactoryCloseDate(null)}
            type="date"
            disabled={loading || closed}
            onChange={(e) => {
              changeFactoryCloseDate(e);
            }}
            value={factoryCloseDateValue}
            datetype={"datetime"}
          />
        </Item>
        <Item ratio={1}>
          <CustomInput
            size={"xxs"}
            disabled={closed}
            onChange={(e) => {
              changeNonPPReason(e);
            }}
            label="Motivo no preferente plus"
            type="text"
            value={nonPPReasonValue} maxValue={200}
          />
        </Item>
      </Box> */}
    </div>
  );
}

export { TaxonomyForm };
